import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';
import type { GetResponse } from '@low6-pickem/api-types';

// Type derived from OpenAPI spec
type TenantsResponse = GetResponse<'/api/admin/tenants'>;
export type Tenant = TenantsResponse['tenants'][number];

export const getTenants = async (): Promise<Tenant[]> => {
  const response = await apiClient.get('/api/admin/tenants');
  return response.tenants || [];
};

export const useGetTenantsQuery = () => {
  return useQuery({
    queryKey: queryKeys.tenants.lists(),
    queryFn: getTenants,
  });
};
